"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tabs = void 0;
var _react = _interopRequireDefault(require("react"));
var _TabsContext = require("./TabsContext");
const Tabs = _ref => {
  let {
    children,
    disableAutoTabFocusWhenSwitching = false,
    manual = false,
    onlyRenderActiveTabPanelChildren = false,
    selectedId,
    onChange,
    renderOn = "work-surface"
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_TabsContext.TabsContextProvider, {
    disableAutoTabFocusWhenSwitching: disableAutoTabFocusWhenSwitching,
    manual: manual,
    onChange: onChange,
    onlyRenderActiveTabPanelChildren: onlyRenderActiveTabPanelChildren,
    renderOn: renderOn,
    selectedId: selectedId
  }, children);
};
exports.Tabs = Tabs;
//# sourceMappingURL=Tabs.js.map